import InformationGroup from './InformationGroup'

export default InformationGroup
